import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Supplier } from '@generated/models';
import SupplierCompany from '@icons/custom/supplier-company-icon.svg';
import SupplierFreelance from '@icons/custom/supplier-freelance-icon.svg';
import { SvgIconComponent } from '@web/shared/components/svg-icon/svg-icon.component';
import { SVG } from '@web/shared/components/svg-icon/svg-icon.types';

@Component({
  selector: 'app-supplier-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgIconComponent],
  template: `
    @let _icon = icon();
    <app-svg-icon [icon]="_icon" class="text-inherit" style="font-size: inherit" />
  `,
  styles: `
    :host {
      display: flex;
    }
  `,
})
export class SupplierIconComponent {
  readonly kind = input.required<Supplier['kind']>();

  readonly icon = computed<SVG>(() => {
    const _kind = this.kind();
    const icons: Record<Supplier['kind'], SVG> = {
      company: SupplierCompany,
      freelance: SupplierFreelance,
    };
    return icons[_kind];
  });
}
